// Listed up front; the view itself (./caged.tsx) loads on demand.
export const id = 'caged';
export const title = 'CAGED visualiser';
export const order = 20;
